export const technical = [
  {
    title: 'React Native / React / Vue',
    progress: 0.95,
    row: 0,
  },
  {
    title: 'Node.js / Nest.js',
    progress: 0.95,
    row: 0,
  },
  {
    title: 'Docker, Monitoring, Network, etc ...',
    progress: 0.85,
    row: 1,
  },
  {
    title: 'HTML/CSS',
    progress: 0.75,
    row: 1,
  },
  {
    title: 'GNU/Linux',
    progress: 0.9,
    row: 2,
  },
  {
    title: 'BI, ETL, BPM ',
    progress: 0.5,
    row: 2,
  },
];

export const professional = [
  {
    title: 'Travail en équipe',
    progress: 0.9,
  },
  {
    title: 'Gestion de projet',
    progress: 0.8,
  },
  {
    title: 'Résolution de problèmes',
    progress: 0.9,
  },
  {
    title: 'Sens artistique',
    progress: 0.7,
  },
];
